import styled from 'styled-components';
import { FlexListItem } from 'styles';

export const FileItem = styled(FlexListItem)`
  padding: 8px 32px;
  border-radius: 8px;
  border-color: ${({ theme }) => theme.colors.gray400};
  gap: 10px;
  width: 100%;
`;
